/**
 * AJAX add-to-cart for product card grid forms.
 * Intercepts submit on [data-product-card-add], POSTs to /cart/add.js,
 * then updates the header cart count and shows a toast without leaving the page.
 */
(function () {
  var toastHideTimeout = null;

  function serializeForm(form) {
    return new URLSearchParams(new FormData(form)).toString();
  }

  function getCartRoutes() {
    var el = document.querySelector('[data-cart-routes]');
    return el ? JSON.parse(el.innerHTML) : null;
  }

  function getToastStrings() {
    var el = document.getElementById('product-card-toast-strings');
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function showToast() {
    var toast = document.getElementById('product-card-toast');
    var strings = getToastStrings();
    if (!toast) return;

    if (toastHideTimeout) {
      clearTimeout(toastHideTimeout);
      toastHideTimeout = null;
    }

    var messageEl = toast.querySelector('.product-card-toast__message');
    var linkEl = toast.querySelector('.product-card-toast__link');
    if (messageEl && strings && strings.added) messageEl.textContent = strings.added;
    if (linkEl && strings && strings.viewCart) linkEl.textContent = strings.viewCart;

    toast.removeAttribute('hidden');
    toast.setAttribute('aria-hidden', 'false');
    toast.classList.add('is-visible');

    toastHideTimeout = setTimeout(function () {
      toast.classList.remove('is-visible');
      toast.setAttribute('aria-hidden', 'true');
      toast.setAttribute('hidden', '');
      toastHideTimeout = null;
    }, 4000);
  }

  function updateHeaderCartCount(count) {
    var countEls = document.querySelectorAll('[data-cart-count]');
    var bubbleEls = document.querySelectorAll('[data-cart-count-bubble]');
    countEls.forEach(function (el) {
      el.textContent = count;
    });
    bubbleEls.forEach(function (el) {
      if (count > 0) {
        el.classList.remove('hide');
      } else {
        el.classList.add('hide');
      }
    });
  }

  function handleSubmit(evt) {
    var form = evt.target;
    if (!form || form.getAttribute('data-product-card-add') === null) return;

    var routes = getCartRoutes();
    if (!routes || !routes.cartAddUrl) return;

    evt.preventDefault();

    var submitBtn = form.querySelector('button[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
    }

    fetch(routes.cartAddUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: serializeForm(form)
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          throw new Error(data.description || 'Cart error');
        }
        return fetch((routes.cartUrl || '/cart') + '.js', { credentials: 'same-origin' });
      })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        updateHeaderCartCount(cart.item_count || 0);
        showToast();
      })
      .catch(function () {
        form.removeAttribute('data-product-card-add');
        form.submit();
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
          // Only restore text for buttons that had text (icon-only buttons keep their SVG)
          if (originalText && originalText.trim()) {
            submitBtn.textContent = originalText;
          }
        }
      });
  }

  document.addEventListener('submit', handleSubmit);
})();
